import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@nike/podium';
import { SidebarProvider } from '~/components/shadcn/sidebar';
import AppSidebar from '~/components/sidebar';
import Header from '../components/header/Header';
import '@nike/podium/styles/core.css';
import '@nike/podium/styles/nike/en-us.css';
import '../global.css';
const BaseContainer = ({ children }) => {
    return (_jsx("div", { "data-pds-theme": "light", children: _jsxs(SidebarProvider, { defaultOpen: false, children: [_jsx(AppSidebar, {}), _jsx(Header, {}), _jsx("div", { className: "pds--globals__content pt-23 w-full", role: "main", children: _jsx(Box, { className: "pds--globals__content-inner px-10", children: children }) })] }) }));
};
export default BaseContainer;
